import React from 'react';

const capabilities = [
  'Disease characterization',
  'Multimodal phenotyping',
  'Screening',
];

const RespiratoryScreening: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-tealLight/30 to-paper">
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <h1 className="font-serif font-bold text-4xl sm:text-5xl leading-tight tracking-tight text-[#085041]">
          <span className="text-[#0F6E56]">Diagnostics</span>
        </h1>

        <p className="mt-6 text-lg leading-relaxed text-slate-700 max-w-3xl">
          Multimodal approaches for disease screening, characterization, and
          phenotyping across clinical and diagnostic data.
        </p>

        <section className="mt-10 bg-white border border-slate-200 rounded-xl p-8 sm:p-10 shadow-[6px_6px_0_rgba(15,110,86,0.14)]">
          <h2 className="font-serif font-bold text-2xl text-[#085041]">
            Diagnostic Capabilities
          </h2>

          <div className="mt-6 grid sm:grid-cols-3 gap-4">
            {capabilities.map((item) => (
              <div
                key={item}
                className="border border-slate-200 rounded-lg p-5 bg-slate-50"
              >
                <p className="text-slate-700 font-medium">{item}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-8 grid md:grid-cols-2 gap-6">
          <div className="bg-white border border-slate-200 rounded-xl p-6">
            <h3 className="font-semibold text-[#085041] mb-3">
              Multimodal Diagnostic Intelligence
            </h3>
            <p className="text-slate-600 leading-relaxed">
              Integrates complementary diagnostic signals to support a richer
              characterization of disease than any single modality alone.
            </p>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl p-6">
            <h3 className="font-semibold text-[#085041] mb-3">
              Translational Applications
            </h3>
            <p className="text-slate-600 leading-relaxed">
              Designed to support screening, disease characterization, and
              research workflows across evolving diagnostic datasets.
            </p>
          </div>
        </section>
      </section>
    </div>
  );
};

export default RespiratoryScreening;
